import type * as React from 'react'
import { cn } from '@/lib/utils'
import { navPillClass } from '@/lib/glass'

// A banner stacked above the bottom nav, drawn as a glass card matching the nav pill.
export function BottomBanner({
  className,
  style,
  testId,
  children,
}: {
  className?: string
  style?: React.CSSProperties
  testId?: string
  children: React.ReactNode
}) {
  return (
    <div
      data-testid={testId}
      data-bottom-banner
      className={cn('px-4 pt-2 animate-in fade-in slide-in-from-bottom-4 duration-300', className)}
      style={style}
    >
      <div className={cn('mx-auto flex max-w-md items-center gap-2.5 rounded-[26px] px-4 py-2', navPillClass)}>
        {children}
      </div>
    </div>
  )
}
